export const i18nConfig = {
  defaultLocale: 'en',
  locales: ['en', 'fr', 'es', 'creole'],
} as const;

export type Locale = (typeof i18nConfig.locales)[number];

export function isValidLocale(locale: string): locale is Locale {
  return i18nConfig.locales.includes(locale as Locale);
}
